import React, { useEffect, useState } from 'react'
//Helpers
import { getFakeAddress, getLocation } from '@helpers/helper.developments'
import { RealEstateDataPageComponentData } from 'types'
import { Col, Container, Row } from 'react-bootstrap'
import useQueryDevelopment from '@hooks/useQueryDevelopment'
import useQueryProperty from '@hooks/useQueryProperty'
import './index.scss'
import { ElementHTML } from '@helpers/helper.rendering'

interface ExternalProps {
  developmentID: string
  propertyID: string
}

type CombinedProps = RealEstateDataPageComponentData & ExternalProps

const LocationDetail_1 = ({
  developmentID,
  propertyID,
  zoom,
  global_data,
  title,
  alignCenter,
  titleSecondary,
  titleElement,
  is_wide,
}: CombinedProps) => {
  const {
    data: allData,
    isLoading,
    isError,
  } = developmentID
    ? useQueryDevelopment(developmentID, global_data.pageConfig.keys.tokko)
    : useQueryProperty(propertyID, global_data.pageConfig.keys.tokko)

  const MapComponent = require(`@components/map/1`)?.default

  const [half, setHalf] = useState(false)

  useEffect(() => {
    var form = document.getElementById('form-detail-float')
    if (form) {
      setHalf(true)
    }
  }, [])

  return !isLoading && !isError ? (
    <section
      className={
        'ubicacion-main a p-y-config ' +
        (is_wide ? 'wide' : '') +
        (half ? ' half-container-fluid-left' : '')
      }
      id="Ubicación"
    >
      <Container fluid>
        <Row>
          <Col xs={12}>
            <Row className={'row' + (alignCenter ? ' text-center' : '')}>
              <Col lg={is_wide ? 2 : 12}>
                <ElementHTML
                  className={
                    'section-title' +
                    (alignCenter ? ' text-center' : '') +
                    (titleSecondary ? ' secondary-color' : '')
                  }
                  children={title || 'Ubicacion'}
                  elementType={titleElement || 'h2'}
                />
              </Col>
              <Col lg={is_wide ? 10 : 12}>
                <p className={'mb-5 pb-lg-0 pb-1' + (alignCenter ? ' text-center' : '')}>
                  {getFakeAddress(allData) +
                    ', ' +
                    getLocation(allData, true)[0] +
                    (allData?.location?.state && !global_data.pageConfig.keys.tokko
                      ? ', ' + allData?.location?.state
                      : '')}
                  {/* <br /> */}
                  {/* {getLocation(allData, true)[1]} */}
                </p>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            {!isLoading && !isError ? (
              <MapComponent
                zoom={zoom || 15}
                data={allData}
                coordenadas={{ geo_lat: allData?.geo_lat, geo_long: allData?.geo_long }}
                global_data={global_data}
              />
            ) : (
              ''
            )}
          </Col>
        </Row>
      </Container>
    </section>
  ) : (
    ''
  )
}

export default LocationDetail_1
